const commentItems = [
  {
    name: '影迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20young%20Asian%20person%20avatar%20with%20stylish%20glasses%2C%20minimal%20dark%20background%2C%20headshot%20portrait%2C%20modern%20casual%20style%2C%20professional%20corporate%20portrait&width=120&height=120&seq=avatar-01&orientation=squarish',
    date: '2026-07-30',
    content: '用了四虎影视大全快两年了，真心推荐！资源更新速度超快，画质清晰，而且真的不卡。现在追剧就认准这里了，同事们也都被我安利过来了哈哈。',
    likes: '2.3万',
    tag: '忠实用户',
  },
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20avatar%20portrait%20with%20warm%20smile%2C%20simple%20dark%20background%2C%20headshot%20photography%2C%20natural%20lighting%2C%20friendly%20and%20approachable%2C%20professional%20portrait&width=120&height=120&seq=avatar-02&orientation=squarish',
    date: '2026-07-29',
    content: '以前用别的平台总是卡顿缓冲，换了四虎影视大全之后完全不一样了。韩剧日剧更新都很快，画质还能选超清，关键是完全免费不用充会员，太良心了！',
    likes: '1.8万',
    tag: '韩剧粉丝',
  },
  {
    name: '电影爱好者老陈',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20avatar%20portrait%20in%20casual%20style%2C%20simple%20dark%20background%2C%20headshot%20photography%2C%20warm%20and%20thoughtful%20expression%2C%20professional%20portrait&width=120&height=120&seq=avatar-03&orientation=squarish',
    date: '2026-07-28',
    content: '作为一个老影迷，四虎影视大全的经典老片库真的让我惊喜。很多小时候看过的港片、老国产剧都能找到，而且画质还修复得很好。周末窝在沙发上看一天老电影，太享受了。',
    likes: '9,632',
    tag: '资深影迷',
  },
  {
    name: '宝妈小周',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20avatar%20portrait%20with%20gentle%20smile%2C%20simple%20dark%20background%2C%20headshot%20photography%2C%20soft%20lighting%2C%20friendly%20and%20warm%20expression%2C%20professional%20portrait&width=120&height=120&seq=avatar-04&orientation=squarish',
    date: '2026-07-27',
    content: '宝宝睡着后的追剧时间就靠四虎影视大全了！手机上看特别方便，不用下载乱七八糟的APP。动漫区资源也超多，有时候白天也会给宝宝放一些适龄的动画片，画质很高看着不伤眼。',
    likes: '1.5万',
    tag: '新用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-500/10 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-chat-heart-line text-xs"></i>
            用户口碑
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            观众热评
          </h2>
          <p className="text-foreground-500 text-sm">听听四虎影视大全用户怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-200/70 rounded-xl border border-background-300/40 p-5 hover:border-background-400/60 transition-all"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden bg-background-300/50">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-200">{item.name}</span>
                    <span className="px-2 py-0.5 rounded-md bg-primary-500/10 text-primary-400 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-foreground-600 text-xs">{item.date}</span>
                </div>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-foreground-500 text-xs">
                <i className="ri-heart-3-fill text-accent-400"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}